// NBL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import Pay from "../Steps/Pay"
// import store from "../../veux/store"

let step1, step2, step4, Countries, Associations, Program, Information, displayMessage, DOB, WomenSizes, MenSizes
let Divisions = ['Divison 1', 'Division 2', 'Division 3', 'Division 4', 'Prefer Not to Say']

const PortalAgeCheck = p => v => {
    let Start = functions.FormatDate(v.Age_Start, 'YYYY-MM-DD')
    let End = functions.FormatDate(v.Age_End, 'YYYY-MM-DD')
    // console.log(Start, End, DOB)
    if (DOB < Start || DOB > End) {
        return `Your Age must be between ${functions.FormatDate(Start, 'DD-MM-YYYY')} to ${functions.FormatDate(End, 'DD-MM-YYYY')} to qualify for this Program`
    }
    return true
}


// FDP Player Step Schema
const Load_FDP_Steps = () => {
    return {
        Portal: '2024 FDP Player',
        MainColor: "#f5924c",
        Logo: require(`../../assets/BQLogo2.png`),
        Title: `<h2>Future Development Program 2024 Registration Form</h2>`,
        Description: `The Future Development Program (FDP)  is aimed at finding the next generation of athlete that could one day represent Queensland. The program will also expose young athletes to a high performance environment, and provide a taste of what to expect if they progress along the High Performance pathway in the future. `,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: `<h4 style="text-align:center;">${displayMessage}</h4>`,
                Schema: {
                    birthCountry: {
                        type: 'select',
                        label: 'Country of Birth',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Country of Birth is Required')],
                        class: 'mx-1 px-1',
                        items: Countries,
                        value: '',
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } }
                    },
                    association: {
                        type: 'select',
                        label: 'Association',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        value: '',
                    },
                    division: {
                        type: 'select',
                        label: 'Division Played',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Division Played is Required')],
                        class: 'mx-1 px-1',
                        items: Divisions,
                        value: '',
                        OUG: { Contact_Details: { Type: 759, Action: "Unique" } }
                    },
                    Shorts: {
                        type: 'select',
                        label: 'Short Size',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Short Size is Required')],
                        class: 'mx-1 px-1',
                        items: MenSizes,
                        returnObject: true,
                        itemText: 'Detail',
                        value: '',
                        onInput: (ev, portal) => {
                            portal.Model.Shorts = ev.obj.value.Detail
                        },
                        OUG: { Contact_Details: { Type: 349, Action: "Unique" } }
                    },
                    Singlet: {
                        type: 'select',
                        label: 'Singlet Size',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Singlet Size is Required')],
                        class: 'mx-1 px-1',
                        items: MenSizes,
                        returnObject: true,
                        itemText: 'Detail',
                        value: '',
                        onInput: (ev, portal) => {
                            portal.Model.Singlet = ev.obj.value.Detail
                        },
                        OUG: { Contact_Details: { Type: 348, Action: "Unique" } }
                    },
                    team: {
                        type: 'select',
                        label: 'Choose Program',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Program is Required'), PortalAgeCheck()],
                        class: 'mx-1 px-1',
                        items: Program,
                        returnObject: true,
                        itemText: 'Detail',
                        // col: 12,
                        value: '',
                        Role: 1,
                        onInput: (ev, portal) => {
                            ev.obj.value.Association = ev.data.association.Code_id
                            portal.Model.ProductDesc = ev.obj.value.Name
                            portal.Model.Amount = ev.obj.value.Price
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    }
                },
                PreStep: (thisStep, portal) => {
                    DOB = functions.FormatDate(portal.Model.DOB, 'YYYY-MM-DD')
                    if (portal.Model.gender === 'Female') {
                        thisStep.Schema.Shorts.items = WomenSizes
                        thisStep.Schema.Singlet.items = WomenSizes
                    } else {
                        thisStep.Schema.Shorts.items = MenSizes
                        thisStep.Schema.Singlet.items = MenSizes
                    }
                },
            },
            // Step 4
            step4,
            // Step 5
            {
                stepno: 5,
                title: 'Finalise',
                valid: true,
                information: `<h2 style="text-align:center;color:red">Important: <br>Please press Submit to Finalise your registration</h2>`,
                Schema: {},
                PostStep: (thisStep, portal) => {
                    functions.sendEmail(
                        {
                            User_Name: 'Future Development Program',
                            User_Email: 'luke.mcguire@basketballqld.net.au',
                            emailstosend: portal.Model.email,
                            Subject: `${portal.Model.team.Detail} Booking Confirmed`,
                            Message: `${portal.Model.team.Terms}`
                        }
                    )
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Finish',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 Future Development Program.</br></br>
                We have sent you a confirmation email and a receipt of your payment.</br></br>
                If you have any queries regarding the program or your registration please contact <a href="mailto:luke.mcguire@basketballqld.net.au">patrick.mcinerney@basketballqld.net.au</a>`,
                Schema: {},
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        step4 = await Pay.LoadSchema(4, Parameters)
        Countries = await functions.GetCountries()
        Associations = await functions.GetCodeBy({ Type: "Associations", Organisation: 292 }, true);
        WomenSizes = await functions.GetCodeBy({ Type: "Women Sizes" }, true);
        WomenSizes.sort((a, b) => a.Code_id - b.Code_id)
        MenSizes = await functions.GetCodeBy({ Type: "Sizes" }, true);
        MenSizes.sort((a, b) => a.Code_id - b.Code_id)
        Program = await functions.getData(`SELECT
                                            Codes.*, Products.*,
                                            (SELECT Messages FROM Codes_Messages WHERE Code_id = 623 AND Type = 'Trials') AS Information
                                        FROM
                                            Codes
                                            INNER JOIN
                                            Products
                                            ON 
                                                Codes.Code_id = Products.Team_id
                                        WHERE
                                            Codes.Code_id = 623 AND
                                            Products.Status = 700`, false);

        // TODO replace this line back in to replace 139
        // Codes.Status = 'Active' AND
        displayMessage = Program[0].Information
        return Load_FDP_Steps()
    },



}

